// Standard agency services across Wolf / Kran / Apex / GBA.
// Used as dropdown options on invoice + recurring forms.
export const SERVICE_OPTIONS = [
  'Marketing',
  'Social Media & Content',
  'Sales',
  'Website',
  'Creatives/Collaterals',
];

// Default payment terms across all new invoices and recurring templates.
export const DEFAULT_PAYMENT_TERMS_DAYS = 7;
